import { FC } from 'react';
import EntitiesSearch from '../../EntitiesSearch';
import { Entity } from '../../../../../api';
import { PopupStateProps } from '@silverfort/sf-components';
import { BindLocalAccountPopupState } from '../types';
import { EntitiesSearchProps } from '../../EntitiesSearch/EntitiesSearch';

type Props = PopupStateProps<BindLocalAccountPopupState>;

const EMPTY_STATE_PROPS: EntitiesSearchProps['emptyStateProps'] = {
    title: 'No AD accounts',
    description: 'Search and select AD accounts to bind'
};

const BindLocalAccountPopupContent: FC<Props> = ({ popupState, setPopupState }) => {
    const { boundEntity } = popupState;
    const selectedEntities = boundEntity ? [boundEntity] : [];

    const handleSelectedEntitiesChange = (entities: Entity[]) => {
        const lastEntity = entities.length > 0 ? entities[entities.length - 1] : undefined;
        setPopupState((prev) => ({ ...prev, boundEntity: lastEntity }));
    };

    return (
        <EntitiesSearch
            selectedEntities={selectedEntities}
            onSelectedEntitiesChange={handleSelectedEntitiesChange}
            enableSelectAll={false}
            enableClearAll={false}
            showCheckboxes={false}
            disableSelection={!!boundEntity}
            emptyStateProps={EMPTY_STATE_PROPS}
        />
    );
};

export default BindLocalAccountPopupContent;
